import { call, select } from 'redux-saga/effects';
import { SALESFORCE_CLIENT_ID } from '../../../../../../shared/config';
import { integrationsApi } from '../../../../../../shared/api/axios/integrations';
import { teamsModel } from '../../../../../../features/teams';
import { getFullUrl } from '../../../../../../shared/lib';

export function* requestSalesforceToken(
  url: string,
  initialStateString: string,
  codeVerifier: string
) {
  const urlParams = new URLSearchParams(url);
  const code: string = yield urlParams.get('code');
  const returnedStateString: string = yield urlParams.get('state');

  if (initialStateString !== returnedStateString) {
    throw new Error('Failed to connect to Salesforce');
  }

  const salesforceCallbackUrl = getFullUrl('auth-callback');

  if (code) {
    const { id: teamId } = yield select(
      teamsModel.selectors.selectCurrentTeamWithError
    );

    yield call(integrationsApi.requestSalesforceAccessToken, {
      code,
      redirectUri: encodeURIComponent(salesforceCallbackUrl),
      clientId: SALESFORCE_CLIENT_ID as string,
      codeVerifier,
      teamId,
    });
  }
  return null;
}
